/**
 * @file _view/_scroll.js
 */
(function($){
	'use strict';

	/**
	 * @namespace Scroll
	 * @constructor
	 * @classdesc ページ内リンクのズレを無くす
	 * @param {Object} $e -対象となる jQuery オブジェクト
	 */
	 var Scroll = function($e) {
	 	this._$e = $e;
	 	this._$e.on('click', this.scrollAdjust.bind(this));
	 };

	/**
	 *
	 * @memberOf Scroll
	 * @const
	 */
	 Scroll._classname = 'Scroll';


	/**
	 * @memberOf Scroll
	 * @return Num
	 */
	 Scroll.prototype.scrollAdjust =  function() {
	 	var headerHeight = $('.header-site').outerHeight();
	 	var speed = 400;
	 	var href = this._$e.attr('href');
	 	var target = $(href === '#' || href === '' ? 'html' : href);
	 	var position = target.offset().top - headerHeight;
	 	$('body, html').animate({
	 		scrollTop: position,
	 	}, speed, 'swing');
	 };

	module.exports = Scroll;
})(jQuery);